import { api } from "../../../api";
import { INotificacao } from "../types";

export const notificacoesApi = {
  async listar(clienteID: string, token?: string): Promise<INotificacao[]> {
    const headers = token ? { Authorization: `Basic ${token}` } : undefined;
    const response = await api.get<{ items: INotificacao[] }>(`/v2/notificacoes/${clienteID}`, { headers });
    return response.data.items;
  },

  async marcarComoLida(notificacaoID: string, clienteID?: string, token?: string): Promise<void> {
    const headers = token ? { Authorization: `Basic ${token}` } : undefined;
    await api.patch(`/v2/notificacoes/${notificacaoID}/ler`, { clienteID }, { headers });
  },

  async marcarTodasComoLidas(clienteID: string, token?: string): Promise<void> {
    const headers = token ? { Authorization: `Basic ${token}` } : undefined;
    await api.patch(`/v2/notificacoes/ler-todas/${clienteID}`, {}, { headers });
  },

  async excluir(notificacaoID: string, clienteID?: string, token?: string): Promise<void> {
    const headers = token ? { Authorization: `Basic ${token}` } : undefined;
    await api.delete(`/v2/notificacoes/${notificacaoID}`, { data: { clienteID }, headers });
  },

  async limparTodas(clienteID: string, token?: string): Promise<void> {
    const headers = token ? { Authorization: `Basic ${token}` } : undefined;
    await api.delete(`/v2/notificacoes/limpar-todas/${clienteID}`, { headers });
  }
};
